import type { Calculation, Employment, UserDefinedRow } from "../model";
import type { CompanyAccountSettings } from "../model";
import { HelpersRoot } from "./helpers/HelpersRoot";

export * from "./model";
export * from "./helpers";
export type { Calculation, CompanyAccountSettings, Employment, UserDefinedRow } from "../model";

/* eslint-disable no-var */

declare global {

  /** Current calculation in the scope of the expression. */
  var calculation: Calculation;

  /** Current row in the scope of the expression. */
  var row: UserDefinedRow;

  /**
   * Current employment object related to the current expression.
   * TODO: May the be undefined if the employment has not been set? Or is this an empty object then?
   */
  var employment: Employment;

  /** The Company settings object for the Employer for which the expression is being evaluated. */
  var settings: CompanyAccountSettings;

  /** The global helper object for expressions. */
  var sxy: HelpersRoot;
}

globalThis.sxy = new HelpersRoot();
